import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Globle } from 'src/assets/globle';
import { Category } from '../../category/category.model';
import { CategoryService } from '../../category/category.service';
import { ExcelService } from '../../excel.service';
import { SubCategory } from '../../subcategory/subCategory.model';
import { SubcategoryService } from '../../subcategory/subcategory.service';
import { Product } from '../product.model';
import { ProductService } from '../product.service';
import * as FileSaver from 'file-saver';
import * as _moment from 'moment';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { LocalStorageService } from 'ngx-webstorage';
import { TranslateService } from '@ngx-translate/core';
import { Prices } from '../prices.model';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

import { MatChipInputEvent } from '@angular/material/chips';
import { ProductCardExcelImport } from '../productcardexcel.model';
import { ExportexcelService } from 'src/app/reports/exportexcel.service';



declare var $: any;

@Component({
  selector: 'app-addproduct',
  templateUrl: './addproduct.component.html',
  styleUrls: ['./addproduct.component.css'],
  providers: [
    // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
    // `MatMomentDateModule` in your applications root module. We provide it at the component level
    // here, due to limitations of our example generation script.
    // {provide: MAT_DATE_LOCALE, useValue: 'ja-JP'},
    // {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    // {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
  queries: {
    contentRef: new ViewChild("Modal")
  },
})
export class AddproductComponent implements OnInit {

  //#region variables
  Categories: Category[] = [];
  subCategories: SubCategory[] = [];
  product: Product = {} as Product;
  updateMode = false;
  imagPath: any;
  files = [];
  files2 = [];
  files3 = [];
  active = true;
  spinnerOverlay = false;
  filteredOptionsCategory!: Observable<Category[]>;
  filteredOptionsSubCategory!: Observable<SubCategory[]>;
  //searchCategory = new FormControl();
  //searchCategory = new FormControl();
  selectedCategory: any
  ProductForm!: FormGroup;
  _submit = false;
  viewImage = false;
  public contentRef!: TemplateRef<any>;
  productCardDeletedIndex = 0;
  lang: any;
  showSoled: boolean = false;
  userCategory: [] = [];
  prices: Prices[] = [];

  selectable = true;
  removable = true;
  addOnBlur = true;

  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl();
  //filteredNo!: Observable<string[]>;
  productsListNo: string[] = [];
  accessories: boolean = false;

  @ViewChild('fruitInput') fruitInput!: ElementRef<HTMLInputElement>;

  //#endregion

  constructor(private router: Router,
    private service: ProductService,
    private categoryService: CategoryService,
    private subCategoryservice: SubcategoryService,
    private globle: Globle,
    private snackBar: MatSnackBar,
    private excelService: ExcelService,
    private dialog: MatDialog,
    private activateRoute: ActivatedRoute,
    private localStorage: LocalStorageService,
    private translate: TranslateService) {
    // this.filteredNo = this.fruitCtrl.valueChanges.pipe(
    //   startWith(null),
    //   map((fruit: string | null) => fruit ? this._filter(fruit) : this.allProductNo.slice()));
  }

  ngOnInit(): void {


    this.connectFormGroup();
    this.imagPath = this.globle.imgPath;
    this.getCategory();
    this.getUrlParam();
    this.lang = this.localStorage.retrieve("lang");
    //  this._adapter.setLocale('en');
  }

  ngAfterViewInit(): void {
    this.loaddropify();
  }

  connectFormGroup() {

    let _productCards = new FormArray([]);
    let userCategory = new FormArray([]);

    this.product.status = 1;
    this.ProductForm = new FormGroup({

      id: new FormControl(null),
      arabicName: new FormControl(null, [
        Validators.required
      ]),
      englishName: new FormControl(null, [
        Validators.required
      ]),
      // userCtegoryPrice:userCategory,
      price1: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      price2: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      price3: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      price4: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      price5: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      price6: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      price7: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      price8: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      price9: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      price10: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      costPrice: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),

      purchaseLimit: new FormControl(0, [
        // Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      dailyPurchaseLimit: new FormControl(0, [
        // Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      subCategoryId: new FormControl(null, [

      ]),
      category: new FormControl(null, [
        Validators.required
      ]),
      subCategory: new FormControl(null, [
        Validators.required
      ]),
      status: new FormControl(this.product.status),
      statusBool: new FormControl(),
      imageUrl: new FormControl(''),
      imageUrl2: new FormControl(''),
      imageUrl3: new FormControl(''),
      direct: new FormControl(false),
      bytic: new FormControl(),
      pyticId: new FormControl(),
      productCards: _productCards!
    });

    this.addProductCardRow();
    // this.getUserCategory();
  }

  getProductCardControls() {
    return (<FormArray>this.ProductForm.get('productCards')).controls;
  }

  addProductCardRow() {
    (<FormArray>this.ProductForm.get('productCards')).push(
      new FormGroup({
        id: new FormControl(""),
        cardNumber: new FormControl(''),
        // [Validators.required, Validators.pattern(/^\S*$/)]
        serialNumber: new FormControl(''),
        expiryDate: new FormControl(''),
        status: new FormControl(0)
      }))
  }

  deleteProductCardRow(index: number) {

    const control = (<FormArray>this.ProductForm.get('productCards'));
    let id = this.getProductCardControls()[index].get("id")?.value;
    if (!this.updateMode || (this.updateMode && id == '')) {
      if (control.length != 1)
        control.removeAt(index);
    }
    else {
      this.productCardDeletedIndex = index;
      this.openDialog()
    }

  }

  getCategory() {
    this.categoryService.getAll(1, this.ProductForm.value.direct).subscribe(data => {
      this.Categories = data

      this.autoCompleatFilterCategory();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  getSubCategory() {
    this.subCategoryservice.getAll(this.selectedCategory, 1).subscribe(data => {
      this.subCategories = data;
      this.autoCompleatFilterSubCategory();
      this.spinnerOverlay = false;
    })
  }

  autoCompleatFilterCategory() {
    this.filteredOptionsCategory = this.ProductForm.get("category")!.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value != null ? value.name : ''),
        map(name => name ? this._filterCategory(name) : this.Categories.slice())
      );
  }

  autoCompleatFilterSubCategory() {
    this.filteredOptionsSubCategory = this.ProductForm.get("subCategory")!.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value != null ? value.name : ''),
        map(name => name ? this._filterSubCategory(name) : this.subCategories.slice())
      );
  }

  _filterCategory(name: string): Category[] {
    const filterValue = name.toLowerCase();
    return this.Categories.filter(option => option.arabicName.toLowerCase().indexOf(filterValue) === 0);
  }

  _filterSubCategory(name: string): SubCategory[] {
    const filterValue = name.toLowerCase();
    return this.subCategories.filter(option => option.arabicName.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFnCategory(category: Category): string {
    return category && category.arabicName ? category.arabicName : '';
  }

  displayFnSubCategory(subCategory: SubCategory): string {
    return subCategory && subCategory.arabicName ? subCategory.arabicName : '';
  }

  loaddropify() {
    var drEvent1 = $('#image1').dropify();
    var drEvent2 = $('#image2').dropify();
    var drEvent3 = $('#image3').dropify();

    drEvent1.on('dropify.afterClear', () => {
      this.product.imageUrl = ""
    });

    drEvent2.on('dropify.afterClear', () => {
      this.product.imageUrl2 = ""
    });


    drEvent3.on('dropify.afterClear', () => {
      this.product.imageUrl3 = ""
    });


  }

  getUrlParam() {
    this.activateRoute.paramMap.subscribe(param => {
      if (param.get("id") != null) {
        this.product.id = +param.get("id")!;
        this.updateMode = true;
        this.getById();
      }
    })
  }

  disableControlsOnUpdate() {
    this.ProductForm.get("category")?.disable();
    this.ProductForm.get("subCategory")?.disable();
    this.getProductCardControls().forEach(control => { control.disable() });
  }

  getById() {
    this.spinnerOverlay = true;
    this.service.getById(this.product.id).subscribe(data => {
      this.product = data
      this.fillControl(data);
      this.spinnerOverlay = false;
      if (data["imageUrl"] != null && data["imageUrl"]) {
        this.fillDropifyImage(this.imagPath + data["imageUrl"]);
        this.viewImage = false;
        //$('#dropifyImage').show();
      }
      if (data["imageUrl2"] != null && data["imageUrl2"]) {
        this.fillDropifyImage2(this.imagPath + data["imageUrl2"]);
      }
      if (data["imageUrl3"] != null && data["imageUrl3"]) {
        this.fillDropifyImage3(this.imagPath + data["imageUrl3"]);
      }
    }, error => {
      this.spinnerOverlay = false;
    })
  }

  fillControl(data: any) {

    this.ProductForm.get("category")!.setValue(data["subCategory"]["category"]);

    this.accessories = data["subCategory"]["category"]["type"] == 5 ? true : false;

    this.ProductForm.get("statusBool")!.setValue(data["status"] ? true : false);

    this.prices = data["lstUserCategoryProduct"];
    let price1 = this.prices.find(x => x.userCategoryId == 1)?.price;
    let price2 = this.prices.find(x => x.userCategoryId == 2)?.price;
    let price3 = this.prices.find(x => x.userCategoryId == 3)?.price;
    let price4 = this.prices.find(x => x.userCategoryId == 4)?.price;
    let price5 = this.prices.find(x => x.userCategoryId == 5)?.price;
    let price6 = this.prices.find(x => x.userCategoryId == 6)?.price;
    let price7 = this.prices.find(x => x.userCategoryId == 7)?.price;
    let price8 = this.prices.find(x => x.userCategoryId == 8)?.price;
    let price9 = this.prices.find(x => x.userCategoryId == 9)?.price;
    let price10 = this.prices.find(x => x.userCategoryId == 10)?.price;

    this.ProductForm.get("price1")!.setValue(price1);
    this.ProductForm.get("price2")!.setValue(price2);
    this.ProductForm.get("price3")!.setValue(price3);
    this.ProductForm.get("price4")!.setValue(price4);
    this.ProductForm.get("price5")!.setValue(price5);
    this.ProductForm.get("price6")!.setValue(price6);
    this.ProductForm.get("price7")!.setValue(price7);
    this.ProductForm.get("price8")!.setValue(price8);
    this.ProductForm.get("price9")!.setValue(price9);
    this.ProductForm.get("price10")!.setValue(price10);

    this.selectedCategory = data["subCategory"]["category"]['id'];

    this.getSubCategory();

    this.ProductForm.patchValue(data);

    (<FormArray>this.ProductForm.get('productCards')).removeAt(0);
    for (let i = 0; i < data["lstProductCards"].length; i++) {

      (<FormArray>this.ProductForm.get('productCards')).push(
        new FormGroup({
          id: new FormControl(data["lstProductCards"][i]["id"]),
          cardNumber: new FormControl(data["lstProductCards"][i]["cardNumber"]),
          serialNumber: new FormControl(data["lstProductCards"][i]["serialNumber"]),
          expiryDate: new FormControl(data["lstProductCards"][i]["expiryDate"]),
          status: new FormControl(data["lstProductCards"][i]["status"]),
        }));
    }
    //this.encodeDecodeCardNo(false);

    this.disableControlsOnUpdate();
    this.addProductCardRow();

    if (this.ProductForm.value.direct) {
      for (let i = 0; i < this.getProductCardControls().length; i++) {
        const control = (<FormArray>this.ProductForm.get('productCards'));
        control.removeAt(i);
      }
    }

  }

  back() {
    this.router.navigate(["./master/cards/products"]);
  }

  encodeDecodeCardNo(encode: boolean) {
    encode ?
      this.getProductCardControls().forEach(control => {
        control.get("cardNumber")?.setValue(btoa(control.get("cardNumber")?.value))
      }) :

      this.getProductCardControls().forEach(control => {
        control.get("cardNumber")?.setValue(atob(control.get("cardNumber")?.value))
      })

  }

  submit() {
    //this.encodeDecodeCardNo(true);

    this.ProductForm.get("subCategoryId")!.setValue(this.ProductForm.get("subCategory")!.value['id']);

    this.spinnerOverlay = true;
    if (this.files.length > 0 || this.files2.length > 0 || this.files3.length > 0) {
      this.uploadImage();
    }
    else {
      !this.updateMode ? this.create() : this.update();
    }
  }

  create() {
    this.service.Create(this.ProductForm.value).subscribe(data => {
      this.spinnerOverlay = false;
      this._submit = true;
      //this.encodeDecodeCardNo(false);
      this.openSnackBar(this.translate.instant("createdSuccessfully"), 'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        //this.encodeDecodeCardNo(false);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }

        this.spinnerOverlay = false;
      })
  }

  update() {

    this.ProductForm.get("status")!.setValue(this.ProductForm.value.statusBool ? 1 : 0)

    this.service.Update(this.ProductForm.value).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      // this.getById();
      this.back();
      //this.encodeDecodeCardNo(false);
    },
      error => {
        console.log(error);
        //this.encodeDecodeCardNo(false);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }
        this.spinnerOverlay = false;
      })
  }

  onSelectImage(event: any) {
    this.files = event.target.files;
  }

  onSelectImage2(event: any) {
    this.files2 = event.target.files;
  }

  onSelectImage3(event: any) {
    this.files3 = event.target.files;
  }

  uploadImage() {

    const formData = new FormData();

    if (this.files.length > 0) {
      let image1 = <File>this.files[0];
      formData.append('imageUrl1', image1, image1.name);
    }

    if (this.files2.length > 0) {
      let image2 = <File>this.files2[0];
      formData.append('imageUrl2', image2, image2.name);
    }

    if (this.files3.length > 0) {
      let image3 = <File>this.files3[0];
      formData.append('imageUrl3', image3, image3.name);
    }

    this.service.uploadImage(formData).subscribe(data => {

      if (data['imagePath1'] != null && data['imagePath1'] != "") {
        this.ProductForm.get("imageUrl")!.setValue(data['imagePath1']);
      }
      if (data['imagePath2'] != null && data['imagePath2'] != "") {
        this.ProductForm.get("imageUrl2")!.setValue(data['imagePath2']);
      }
      if (data['imagePath3'] != null && data['imagePath3'] != "") {
        this.ProductForm.get("imageUrl3")!.setValue(data['imagePath3']);
      }

      !this.updateMode ? this.create() : this.update();
    }, error => {
      console.log(error);
      this.openSnackBar(error.error.message, 'snackBarError');
      this.spinnerOverlay = false;
    });
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  fillDropifyImage(imgUrl: any) {
    var drEvent = $('#image1').dropify(
      {
        defaultFile: imgUrl
      });
    drEvent = drEvent.data('dropify');
    drEvent.resetPreview();
    //drEvent.clearElement();
    drEvent.settings.defaultFile = imgUrl;
    drEvent.destroy();
    drEvent.init();
  }

  fillDropifyImage2(imgUrl: any) {
    var drEvent = $('#image2').dropify(
      {
        defaultFile: imgUrl
      });
    drEvent = drEvent.data('dropify');
    drEvent.resetPreview();
    //drEvent.clearElement();
    drEvent.settings.defaultFile = imgUrl;
    drEvent.destroy();
    drEvent.init();
  }

  fillDropifyImage3(imgUrl: any) {
    var drEvent = $('#image3').dropify(
      {
        defaultFile: imgUrl
      });
    drEvent = drEvent.data('dropify');
    drEvent.resetPreview();
    //drEvent.clearElement();
    drEvent.settings.defaultFile = imgUrl;
    drEvent.destroy();
    drEvent.init();
  }

  selectCatChange(value: any) {

    this.accessories = value.type == 5 ? true : false;
    this.loaddropify();
    this.spinnerOverlay = true;
    this.selectedCategory = value.id;

    this.getSubCategory();
  }

  addNew() {

    this.ProductForm.reset();
    this.subCategories = [];
    //this.sizelist = [];
    //this.filteredOptionsSubCategory = null;
    $('#dropifyImage').hide();
    this.viewImage = false;
    for (let i = 0; i < this.getProductCardControls().length; i++) {
      this.deleteProductCardRow(i);
    }
    this.fillDropifyImage(null);
    this.fillDropifyImage2(null);
    this.fillDropifyImage3(null);
    this._submit = false;
  }

  viewDropify() {
    //this.loaddropify();
    this.viewImage = !this.viewImage;
    !this.viewImage ? $('#dropifyImage').hide() : $('#dropifyImage').show();

  }

  Import() {
    $('#file-input').trigger('click');
  }

  importCards(event: any) {

    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {

      const bstr: string = e.target.result;

      const data = <string[]>this.excelService.importFromFile(bstr);
      console.log(data)
      if (!this.updateMode) {
        for (let i = 0; i < (<FormArray>this.ProductForm.get('productCards')).length; i++) {
          (<FormArray>this.ProductForm.get('productCards')).removeAt(i);
        }
      }

      for (let i = 1; i < data.length; i++) {
        (<FormArray>this.ProductForm.get('productCards')).push(
          new FormGroup({
            id: new FormControl(""),
            cardNumber: new FormControl(data[i][0]),
            serialNumber: new FormControl(data[i][1]),
            expiryDate: new FormControl(new Date(data[i][2])),
            status: new FormControl(0)
          }))
      }
    };
    reader.readAsBinaryString(target.files[0]);
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  deleteProductCard(index: number) {

    let id = this.getProductCardControls()[index].get("id")?.value;
    this.dialog.closeAll();
    this.service.deleteProductCard(id).subscribe(data => {
      this.openSnackBar(this.translate.instant("deletedSuccessfully"), 'snackBarSuccess');

      const control = (<FormArray>this.ProductForm.get('productCards'));
      control.removeAt(index);

      if (this.getProductCardControls().length == 0) {
        this.addProductCardRow();
      }
    },
      error => {
        console.log(error);
        this.openSnackBar("Internal server error", 'snackBarError');
      })
  }

  confirmDelete() {
    this.deleteProductCard(this.productCardDeletedIndex);
  }

  onShowSoled() {
    this.showSoled = !this.showSoled
  }

  downloadTemp() {
    FileSaver.saveAs("../../../assets/CardList.xlsx");
  }

  onDirectChargedChanged() {
    this.ProductForm.get("category")!.setValue("");
    this.ProductForm.get("subCategory")!.setValue("");

    if (this.ProductForm.value.direct) {
      for (let i = 0; i < this.getProductCardControls().length; i++) {
        const control = (<FormArray>this.ProductForm.get('productCards'));
        control.removeAt(i);
      }
    }
    else {
      this.addProductCardRow();
    }

    this.getCategory();
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    let value2 = event.value.split(' ');


    for (let i = 0; i < value2.length; i++) {
      if (value2[i]) {
        this.productsListNo.push(value2[i]);
      }

    }
    // Add our fruit
    // if (value) {
    //   this.fruits.push(value);
    // }

    // Clear the input value
    event.input.value = "";

    this.fruitCtrl.setValue(null);
  }

  remove(fruit: string): void {
    console.log(fruit)
    const index = this.productsListNo.indexOf(fruit);

    if (index >= 0) {
      this.productsListNo.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.productsListNo.push(event.option.viewValue);
    this.fruitInput.nativeElement.value = '';
    this.fruitCtrl.setValue(null);
  }

  clearCardsNo() {
    this.productsListNo = [];
  }

  addCardsToList() {

    let cards = (<FormArray>this.ProductForm.get('productCards'));
    cards.removeAt(cards.length - 1);

    var d = new Date();
    var year = d.getFullYear() + 1;
    var month = d.getMonth();
    var day = d.getDate();

    let cardExpDate = month + "/" + day + "/" + year;
    var date = new Date(year, month, day);

    for (let i = 0; i < this.productsListNo.length; i++) {

      (<FormArray>this.ProductForm.get('productCards')).push(
        new FormGroup({
          id: new FormControl(''),
          cardNumber: new FormControl(this.productsListNo[i]),
          serialNumber: new FormControl(),
          expiryDate: new FormControl(date),
          status: new FormControl(0),
        }));

    }

    this.productsListNo = [];

  }

  exportCardsToExcel() {
    var controls = this.getProductCardControls();
    var exportList = [];

    for (let i = 0; i < controls.length; i++) {
      if (controls[i].value.id != '' && controls[i].value.id != null) {

        const formattedDate = this.formatDate(controls[i].value.expiryDate);
        var obj = {
          "card_Number": controls[i].value.cardNumber,
          "serial_Number": controls[i].value.serialNumber,
          "expiry_Date ": formattedDate,
        }
        exportList.push(obj);
      }
    }

    if (exportList.length > 0) {
      var catgName = this.ProductForm.get("category")?.value;
      var subCatgName = this.ProductForm.get("subCategory")?.value;
      var productName = this.ProductForm.get("englishName")?.value;

      this.excelService.exportAsExcelFile(exportList, "Product_Cards_" +
        catgName.englishName + "_" + subCatgName.englishName + "_" + productName);
    }
    else {
      this.openSnackBar("لا يوجد بطاقات", 'snackBarError');
    }
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);

    // Get day, month, and year
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
}


